<template>
  <div class="">
    <el-dialog custom-class="pu-dialog" :show-close="false" :visible.sync="dialogVisible" :width="width" :center="center" :append-to-body="appendToBody" @close="handleClose">
      <template v-slot:title>
        <div class="header-title">
          <span class="title-text">{{ title }}</span>
          <el-link type="text" class="title-close" @click="handleClose" icon="el-icon-close" :underline="false"></el-link>
        </div>
      </template>
      <template>
        <div class="dialog-body" v-loading="showLoading" :style="{ padding: padding, textAlign: textAlign }">
          <transition name="el-zoom-in-top">
            <div class="mb-[10] mx-[auto]" :style="alertStyle" v-show="tips.msg">
              <el-alert
                class=""
                @close="
                  () => {
                    tips.msg = '';
                  }
                "
                v-show="tips.msg"
                :title="tips.msg"
                :type="tips.type"
                show-icon
              >
              </el-alert>
            </div>
          </transition>
          <slot name="content"></slot>
        </div>
      </template>
      <template v-slot:footer>
        <div class="flex justify-center" :style="footerStyle" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "dgDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    alertStyle: {
      type: Object,
      default() {
        return {};
      },
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "标题",
    },
    width: {
      type: String,
      default: "480px",
    },
    center: {
      type: Boolean,
      default: true,
    },
    padding: {
      type: String,
      default: "20px 25px",
    },
    textAlign: {
      type: String,
      default: "center",
    },
    footerStyle: {
      type: Object,
      default: () => {
        return {
          padding: "0 20px 40px",
        };
      },
    },
  },
  watch: {
    visible(val) {
      // this.dialogVisible = val
      if (val) {
        this.handleOpen();
      } else {
        this.handleClose();
      }
    },
  },
  data() {
    return {
      dialogVisible: false,
      showLoading: false,
      tips: {
        msg: "",
        type: "error",
      },
    };
  },
  created() {},
  mounted() {
    Mirror.watch("loading_dg_form_dialog_open", () => {
      this.showLoading = true;
    });
    Mirror.watch("loading_dg_form_dialog_close", () => {
      this.showLoading = false;
    });
    let time = null;
    Mirror.watch(["tips_dg_form_dialog_open", "tips_dg_form_dialog"], (key, msg) => {
      if (typeof msg == "string") {
        this.tips.msg = msg;
        this.tips.type = "error";
      } else {
        if (msg.type == "success") {
          clearInterval(time);
          setTimeout(() => {
            this.tips.msg = "";
          }, 3000);
        }

        this.tips.msg = msg.msg;
        this.tips.type = msg.type;
      }
    });
    Mirror.watch("tips_dg_form_dialog_close", () => {
      this.tips.msg = "";
    });
  },

  methods: {
    handleClose() {
      Mirror.emit("dg_form_dialog_close");
      this.dialogVisible = false;
      this.$emit("handleClose");
    },
    handleOpen() {
      Mirror.emit("dg_form_dialog_open");
      Mirror.emit('tips_dg_form_dialog_close'); // 清空提示
      this.dialogVisible = true;
      this.$emit("handleOpen");
    },
  },
};
</script>
<style scoped lang="less">
// @import '~@/assets/css/var.less';

/deep/ .pu-dialog {
  background-color: #ffffff;

  .el-dialog__header {
    padding: 30px 20px 10px !important;

    .header-title {
      line-height: 24px;
      font-size: 18px !important;
      color: #303133;
      position: relative;

      .title-close {
        padding: 0 !important;
        line-height: 24px;
        top: 0;
        float: right;
        font-size: 20px;
        color: #303133;
        position: absolute;
        right: 0;

        .el-icon-close {
          font-size: 24px !important;
        }
      }
    }
  }

  .el-dialog__body {
    padding: 0 !important;
  }

  .el-dialog__footer {
    padding: 0px !important;

    .el-button {
      width: 120px;
    }
  }
  .dialog-cont {
    padding: 25px 25px 30px;
  }
}
</style>
